import { render } from "./CustomNodesPage.vue?vue&type=template&id=1b73220c"
import script from "./CustomNodesPage.vue?vue&type=script&lang=js"
export * from "./CustomNodesPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__